import type { Theme } from '@mui/material/styles';

import type { Severity } from '../types/domain.types';

import { SEVERITY_TONE } from './severityTone';

export const BANNER_VISIBLE_MS = 8_000;

export const BANNER_VISIBLE_MS_BY_SEVERITY: Readonly<Record<Severity, number | null>> = {
  EMERGENCY: null,
  MAJOR: null,
  MINOR: BANNER_VISIBLE_MS,
  CAUTION: BANNER_VISIBLE_MS,
};

export const bannerVisibleMs = (severity: Severity): number | null => BANNER_VISIBLE_MS_BY_SEVERITY[severity];

export const IN_APP_CARD_MAX = 440;

export const ALERTS_RETRY_MS = 30_000;

export const ALARM_PULSE_MS = 1_000;

export const severityAccent = (severity: Severity): string => {
  const tone = SEVERITY_TONE[severity];
  return severity === 'EMERGENCY' ? tone.bg : tone.border ?? tone.fg;
};

type StyleTree = Readonly<Record<string, unknown>>;

export interface InsetTree {
  readonly [key: string]: string | InsetTree;
}

const isStyleTree = (value: unknown): value is StyleTree => typeof value === 'object' && value !== null;

const lengthOf = (value: number | string): string => (typeof value === 'number' ? `${value}px` : value);

export const belowToolbar = (toolbar: StyleTree, gap: string): InsetTree => {
  const offsets: Record<string, string | InsetTree> = {};
  Object.entries(toolbar).forEach(([key, value]) => {
    if (key === 'minHeight' && (typeof value === 'number' || typeof value === 'string')) {
      offsets.insetBlockStart = `calc(${lengthOf(value)} + ${gap})`;
    } else if (isStyleTree(value)) {
      offsets[key] = belowToolbar(value, gap);
    }
  });
  return offsets;
};

export const bannerAnchorSx = (theme: Theme): InsetTree => {
  const phone = {
    insetBlockEnd: 'auto',
    insetInlineStart: theme.spacing(4),
    insetInlineEnd: theme.spacing(4),
    transform: 'none',
  };
  const top = belowToolbar(theme.mixins.toolbar, theme.spacing(2));
  const sm = theme.breakpoints.up('sm');
  const atSm = top[sm];
  const topAtSm = typeof atSm === 'object' ? atSm : {};
  return {
    ...phone,
    ...top,
    [sm]: { ...topAtSm, ...phone },
    [theme.breakpoints.up('md')]: {
      insetBlockStart: 'auto',
      insetBlockEnd: theme.spacing(6),
      insetInlineStart: 'auto',
      insetInlineEnd: theme.spacing(6),
      transform: 'none',
    },
  };
};
